module.exports = __webpack_public_path__ + "static/media/retos_card.0b91b97e.png";